module.exports = __webpack_public_path__ + "static/media/2021-trainingslager-robert.b20f2a9a.jpg";